import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const SocialProof = () => {
  return <section className="bg-gray-50 px-4 py-8 md:py-16 lg:px-8" data-id="element-227">
      <div className="mx-auto max-w-3xl" data-id="element-228">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center" data-id="element-229">
          {/* Testimonial Text Only */}
          <div className="space-y-6" data-id="element-230">
            <div className="flex justify-center space-x-1" data-id="element-231">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-6 w-6 fill-yellow-400 text-yellow-400" data-id="element-232" />)}
            </div>

            <h3 className="font-serif text-2xl font-bold text-text-dark" data-id="element-233">
              "¡Definitivamente vale la pena!"
            </h3>

            <blockquote className="text-lg italic text-text-dark/80" data-id="element-234">
              "Estamos muy contentos de haber hecho esta compra y preparación.
              ¡Lo más difícil de la cena ahora es solo acordarse de sacar la
              bolsa del congelador. ¡Totalmente vale la pena!!"
            </blockquote>

            <p className="font-bold text-terracotta" data-id="element-235">
              — Elena, usuaria del Protocolo de Cenas de Paz.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};